import SkinColor from './SkinColor'
export default SkinColor
